import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as routes from '../../../../constants/routes';
import BreadCrumbs from '../../../../components/common/bread_crumbs';
import './index.scss';
const TopBanner = ({ children, additionalBreadcrumb = undefined, legalAdvicePage }) => {
    const deviceState = useSelector((store) => store.state.deviceState);


    const rootBreadcrumb = {
        text:'דף הבית',
        route: routes.home,
    };

    const breadcrumbsList = [
        {
            text: 'צרכנות חכמה',
            route: routes.magazine,
        },
        {
            text: 'ייעוץ משפטי',
            route: routes.legal_advice,
        },
    ];

    if (additionalBreadcrumb) {
        breadcrumbsList.push(additionalBreadcrumb);
    }

    return (
        <div className="legal-advice-top-banner">
            <div className="banner-container">
                {deviceState === 'mobile' && (
                    <BreadCrumbs
                        root={rootBreadcrumb}
                        crumbs={breadcrumbsList}
                        className="banner-breadcrumbs banner-breadcrumbs_upper"
                    />
                )}

                <div className="banner-content">
                    {children ?? (
                        <>
                            <p className="banner-subtitle">
                                {legalAdvicePage.page.header_subtitle}
                            </p>

                            <h3 className="banner-title">
                                {legalAdvicePage.page.header_title}
                            </h3>

                            <p className="banner-description">
                                {legalAdvicePage.page.header_description}
                            </p>
                        </>
                    )}
                </div>
            </div>

            {deviceState !== 'mobile' && (
                <BreadCrumbs
                    root={rootBreadcrumb}
                    crumbs={breadcrumbsList}
                    className="banner-breadcrumbs"
                />
            )}
        </div>
    );
};

export default TopBanner;
